import React from 'react';
import { Container } from '../../atoms/container/Container';
import { Text } from '../../atoms/text/Text';
import style from './AmbulanceAvailable.module.scss';

interface AmbulanceAvailableProps {
    isAmbulanceAvailable: string;
}

export const AmbulanceAvailable: React.FC<AmbulanceAvailableProps> = ({ isAmbulanceAvailable }) => {
    return (
        <Container className={style.horizon_wrapper}>
            <Container className={style.label}>
                <Text text="Matched City:" className={style.title} />
            </Container>
            <Container className={style.input_wrapper}>
                {isAmbulanceAvailable}
            </Container>
        </Container >
    )
}